import { QueryClient, useMutation, useQuery } from '@tanstack/react-query'
import React, { useEffect, useState } from 'react'
import Loading from '../Loading'
import axios from 'axios'
import { Link, useNavigate } from 'react-router-dom'
import { getData } from '../myComponents/QuranApi';
import { IoHomeOutline } from "react-icons/io5";
import { GiCardExchange } from "react-icons/gi";

const Q1 = () => {
  const queryClient = new QueryClient();
  const [mushafView, setMushafView] = useState(false);
  const navigate = useNavigate();
  let verse = localStorage.getItem("q1");

  const handleToggleView = () => {
    setMushafView(!mushafView);
  }

  useEffect(() => {
    queryClient.invalidateQueries({ queryKey: ["view"] });
    queryClient.invalidateQueries({ queryKey: ["textview"] });
  }, [verse])



  return (<>
    <div>
      <div className=''>{mushafView ? <MushafView d={verse} handleBtn={handleToggleView}/> : <TextView d={verse} handleBtn={handleToggleView}/>}</div>
    </div>
  </>
  )
}

export default Q1;

const TopBar1 = (props) => {
  const rdata = localStorage.getItem("questions");
  const data = JSON.parse(rdata)
  const qdata = data?.q1
  console.log(qdata)
  return (
    <>
    <div className='arabic flex justify-around pagehead -mb-5'>
      <div className='flex'>
        <div className='bg-purple-900 text-white rounded-full px-2 lg:px-5'>1</div>
        <div className='bg-indigo-400 rounded-full px-2 lg:px-5'><span> سورة </span> <span>: {qdata?.sura_name_ar} </span> - <span> الآية </span> <span>: {qdata?.aya_number} </span></div>
      </div>
      <Link className=' hover:text-yellow-400  hover:ring-1 hover:ring-red-600 bg-green-900 text-white rounded-full px-2 lg:px-5' to={"/q2"}>NEXT</Link>
         
    <div className='flex justify-start gap-2'>
      <div className='bg-indigo-400 rounded-full px-2 lg:px-5'><span> الصفحة </span> <span>: {qdata?.page} </span></div>
      <button onClick={props.handleToggleView} className='hover:text-red-500 bg-indigo-300 rounded-full px-2 lg:px-5'><GiCardExchange size={19} /></button>
      <div className='hover:text-red-500 bg-indigo-300 rounded-full px-2 lg:px-5 lg:pt-5'><span> <IoHomeOutline size={20}  /> </span></div>
    </div>
    
    </div>
    </>
  )
}


const TextView = (props) => {
  const vid = localStorage.getItem("q1");
  const [datas, setDatas] = useState([])
  let page = "";

  const { mutate, isLoading, isFetching, reset } = useMutation({
    mutationKey: ['textview'],
    mutationFn: async (verse) => {
      //const { data: vdata } = await axios.get(`https://api.quran.com/api/v4/verses/by_key/${versekey}`)
      // const vdata = getData("vid", verse)[0]
      const vid = localStorage.getItem("q1");
      const verseId = parseInt(vid)
      const vdata = getData("vid", verseId)[0]
      console.log("vdata", vdata)
      let page = vdata?.page;
      // const verseId = vdata?.oid;
      const page1 = getData("page", page)
      const page2 = getData("page", parseInt(page) + 1)
      const pages = [...page1, ...page2];
      const filtered = pages.filter(p => p.vid >= verseId)
      console.log(filtered)
      setDatas(filtered);
      return filtered
    }
  })

  useEffect(() => {
    reset()
    mutate(vid)
  }, [])

  useEffect(() => {
    reset()
    mutate(vid)
  }, [vid])

  if (isLoading || isFetching) return <div className='p-10'><Loading /></div>

  return (<>

    <TopBar1  handleToggleView={props.handleBtn}/>

    <div className="viewcontainer ring-2 ring-black">
      <div className='px-1 pt-3  ring-2 ring-black rounded-lg'>
        {datas?.map((p, i) => (
          <span
            key={i}
            className="ayah"
          >
            {p?.verse_text_vn}{datas?.length === 0 && <Loading />}
          </span>
        ))}
      </div>
      {/* <span className='text-2xl'>ٱلَّذِینَ یُؤۡمِنُونَ بِٱلۡغَیۡبِ</span> */}
    </div>
    <div className='text-center -m-2 xl:text-2xl'>
      {page}


    </div>
  </>
  );
}


const MushafView = (props) => {
  const vid0 = localStorage.getItem("q1")
  const vid = parseInt(vid0)
  console.log('ver', vid)
  const [page, setPage] = useState([])

  const { mutate, isLoading, isFetching, reset } = useMutation({
    mutationKey: ['mushafview'],
    mutationFn: async (vid) => {
      //const { data: vdata } = await axios.get(`https://api.quran.com/api/v4/verses/by_key/${versekey}`)
      const vdata = getData("vid", vid)[0]
      const cpage = vdata?.page
      console.log("cpage", cpage)
      setPage(cpage)
      return cpage;
    }
  })

  useEffect(() => {
    reset()
    mutate(vid)
  }, [])

  useEffect(() => {
    reset()
    mutate(vid)
  }, [vid])

  if (isLoading || isFetching) return <div className='p-10'><Loading /></div>

  return (<>

    <TopBar1  handleToggleView={props.handleBtn}/>
    
    <div className="viewcontainer ring-2 ring-black flex">
      <div className='p-2 ring-2 ring-black rounded-lg'>
        <img height={10} src={`./quran-images/${parseInt(page)}.png`} alt="" />
        <span className='absolute text-red-900 bg-slate-400 rounded-full -mb-3 xl:text-2xl'>{parseInt(page)}</span>
      </div>
      <div className='p-2 ring-2 ring-black rounded-lg'>
        <img height={10} src={`./quran-images/${parseInt(page) + 1}.png`} alt="" />
        <span className='absolute text-red-900 bg-slate-400 rounded-full -mb-3 xl:text-2xl'>{parseInt(page) + 1}</span>
      </div>
    </div>
    {/* {JSON.stringify(page)} */}
  </>
  );
}



const Button = (props) => {
  return (
    <button
      onClick={props.onClick}
      className={`buttonnav cursor-pointer text-white rounded-full px-2 ${props.styles}`}
    >
      {props.label}
    </button>
  );
}

